var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { showAlert as showAlertAction, showNotification as showNotificationAction, } from '../../../actions/NotificationActions';
import { apiUpdateProfile } from '../../../actions/ProfileActions';
import { FREE_CAREER_CHANGE_CANDIDATES, FREE_ON_SITE_CANDIDATES, FREE_UNIT_CANDIDATES, } from '../../../define/consts/profile';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { relationFilterByFree } from '../../../helpers/common/ProfessionalInformationHelper';
import { propArrayShape, propFunc, propShape, PropTypesAuthToken, } from '../../../helpers/custom-prop-types';
import { uploadFilePromiseAndGetTemporaryId } from '../../../helpers/files';
import { hasRequiredParam } from '../../../helpers/user/UserProfileHelper';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import OuterFormConsultantProfileSticky from '../../Ui/Professional/Profile/FormConsultantProfileStickyClass';
import FormProfileEdit from './FormProfileEdit';
class ProfileEdit extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
            const { showAlert, showNotification, updateProfile, uploadFile } = this.props;
            const { baseSkills, cardPhoto, career, especiallyMiddleTasks, experienceList, experiencedIndustryList, fileId, middleTasks, middleTasksOther, projectCareer, relatedPortfolios } = values, addValue = __rest(values, ["baseSkills", "cardPhoto", "career", "especiallyMiddleTasks", "experienceList", "experiencedIndustryList", "fileId", "middleTasks", "middleTasksOther", "projectCareer", "relatedPortfolios"]);
            try {
                const convertCheckBoxList = (list) => list
                    .map((value, key) => ({ id: key, value }))
                    .filter(({ value }) => value)
                    .map(({ id }) => id);
                const convertCheckBoxObjectList = (list) => list
                    .map((value, key) => (value ? Object.assign(Object.assign({}, value), { id: key }) : null))
                    .filter((v) => v);
                const especiallyMiddleTasksIdList = convertCheckBoxList(especiallyMiddleTasks);
                const convertRelatedPortfolios = yield Promise.all(relatedPortfolios.map((portfolioObj) => (() => __awaiter(this, void 0, void 0, function* () {
                    const { id, title, uploadRawFile } = portfolioObj;
                    const newObj = {
                        title,
                    };
                    if (id) {
                        newObj.id = id;
                    }
                    if (uploadRawFile) {
                        newObj.uploadFileId = yield uploadFile(uploadRawFile);
                    }
                    return newObj;
                }))()));
                const newValues = Object.assign(Object.assign({}, addValue), { baseSkills: convertCheckBoxObjectList(baseSkills), career: career
                        .filter((v) => !isNullOrUndefinedOrEmpty(v.title) &&
                        !isNullOrUndefinedOrEmpty(v.content))
                        .map((v) => ({
                        content: v.content,
                        date: `${v.year}-${v.month}-1`,
                        position: v.position || '',
                        title: v.title,
                    })), experienceList: convertCheckBoxList(experienceList), experiencedIndustryList: convertCheckBoxList(experiencedIndustryList), middleTasks: convertCheckBoxList(middleTasks).map((v) => ({
                        especially: especiallyMiddleTasksIdList.includes(v) ? 1 : 0,
                        id: v,
                        otherTask: middleTasksOther[v] || null,
                    })), projectCareer: projectCareer
                        .filter((v) => !isNullOrUndefinedOrEmpty(v.title) &&
                        !isNullOrUndefinedOrEmpty(v.content))
                        .map((v) => ({
                        content: v.content,
                        date: `${v.year}-${v.month}-1`,
                        position: v.position || '',
                        title: v.title,
                    })), relatedPortfolios: convertRelatedPortfolios });
                // 名刺
                if (fileId && fileId instanceof File) {
                    newValues.fileId = yield uploadFile(values.fileId);
                }
                // 写真
                if (cardPhoto && cardPhoto instanceof File) {
                    newValues.cardPhoto = yield uploadFile(values.cardPhoto);
                }
                yield updateProfile(newValues);
                showNotification('プロフィールを更新しました。');
                if (this.onSubmitCompleteCallback) {
                    this.onSubmitCompleteCallback(true);
                }
            }
            catch (e) {
                if (this.onSubmitCompleteCallback) {
                    this.onSubmitCompleteCallback(false);
                }
                showAlert('システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
                throw e;
            }
        });
        this.getCareers = (args) => {
            const list = args ? [...args] : [];
            if (list.length === 0) {
                list.push({ date: new Date() });
            }
            return list.map((row) => {
                const { date } = row, addRow = __rest(row, ["date"]);
                const momentDate = moment(date);
                return Object.assign({ month: momentDate.format('M'), year: momentDate.format('YYYY') }, addRow);
            });
        };
        this.getInitialValues = (props, categoryStates) => {
            const { profile } = props;
            const { baseSkills, middleTasks } = categoryStates;
            const { freeInformation: rawInformation, information } = profile;
            // 明示的なnull設定を考慮し、空オブジェクトを初期値設定しておく
            const freeInformation = rawInformation || {};
            const { baseSkills: rawBaseSkills, experiencedIndustryClasses, experiences, } = information;
            const experienceList = [];
            (experiences || []).forEach((v) => {
                experienceList[v.id] = true;
            });
            const experiencedIndustryList = [];
            (experiencedIndustryClasses || []).forEach((v) => {
                experiencedIndustryList[v.id] = true;
            });
            const setBaseSkills = [];
            baseSkills.forEach((skill) => {
                if (skill.isAdmin) {
                    return;
                }
                const userData = (rawBaseSkills || []).find((v) => v.id === skill.id);
                setBaseSkills[skill.id] = {
                    id: skill.id,
                    level: userData ? userData.level : 5,
                };
            });
            const setMiddleTasks = [];
            const setMiddleTasksOther = [];
            const setEspeciallyMiddleTasks = [];
            (information.middleTasks || []).forEach((v) => {
                const middleTask = middleTasks.find(({ id }) => id === v.id);
                const { isOther } = middleTask || {};
                setMiddleTasks[v.id] = true;
                if (v.especially) {
                    setEspeciallyMiddleTasks[v.id] = true;
                }
                if (isOther) {
                    setMiddleTasksOther[v.id] = v.name;
                }
            });
            const careers = this.getCareers(information.careers);
            const projectCareers = this.getCareers(information.projectCareers);
            const unitDefault = FREE_UNIT_CANDIDATES[0].value;
            const onSiteDefault = FREE_ON_SITE_CANDIDATES[0].value;
            const careerChangeDefault = FREE_CAREER_CHANGE_CANDIDATES[0].value;
            const fixFloat = (v) => {
                if (isNullOrUndefinedOrEmpty(v)) {
                    return v;
                }
                const matches = v.toString().match(/^(.+)\.0$/);
                if (matches) {
                    return parseInt(matches[1], 10);
                }
                return v;
            };
            const addDefaultRow = (rows = []) => {
                if (rows.length === 0) {
                    return [{}];
                }
                return rows;
            };
            return {
                assignable: freeInformation.assignable,
                // あなたについて
                baseSkills: setBaseSkills,
                cardPhoto: information.cardPhoto,
                career: careers,
                careerChange: (freeInformation.careerChange || careerChangeDefault).toString(),
                consultingFirmExperience: freeInformation.consultingFirmExperience,
                description: information.description,
                desiredFeePerDay: fixFloat(freeInformation.desiredFeePerDay),
                desiredFeePerHour: fixFloat(freeInformation.desiredFeePerHour),
                email: profile.email,
                especiallyMiddleTasks: setEspeciallyMiddleTasks,
                experience: information.experience,
                // 経歴
                experienceList,
                experiencedIndustryList,
                fileId: information.file,
                firstName: information.firstName,
                firstNameKana: information.firstNameKana,
                // 基本情報
                id: profile.id,
                lastName: information.lastName,
                lastNameKana: information.lastNameKana,
                middleTasks: setMiddleTasks,
                middleTasksOther: setMiddleTasksOther,
                minimumFeePerDay: fixFloat(freeInformation.minimumFeePerDay),
                minimumFeePerHour: fixFloat(freeInformation.minimumFeePerHour),
                nominalNumber: `0000${freeInformation.nominalNumber}`.slice(-4),
                onSite: (freeInformation.onSite || onSiteDefault).toString(),
                organization: (profile.organization || {}).name,
                password: '',
                phone1: information.phone1,
                phone2: information.phone2,
                phone3: information.phone3,
                projectCareer: projectCareers,
                relatedPortfolios: addDefaultRow(freeInformation.relatedPortfolios),
                sex: information.sex ? information.sex.toString() : '1',
                // 契約条件
                situation: information.situation ? information.situation.toString() : '1',
                unitTime: (freeInformation.unitTime || unitDefault).toString(),
            };
        };
        this.getState = (props, state) => {
            const { baseSkills: rawBaseSkills, experienceClasses: rawExperienceClasses, experiencedIndustries: rawExperiencedIndustries, largeTasks: rawLargeTasks, middleTasks: rawMiddleTasks, } = props;
            const baseSkills = rawBaseSkills.filter(relationFilterByFree);
            const experienceClasses = rawExperienceClasses.filter(relationFilterByFree);
            const experiencedIndustries = rawExperiencedIndustries.filter(relationFilterByFree);
            const largeTasks = rawLargeTasks.filter(relationFilterByFree);
            const middleTasks = rawMiddleTasks.filter((middleTask) => !!largeTasks.find((largeTask) => largeTask.id === middleTask.largeTaskId));
            const categoryStates = {
                baseSkills,
                experienceClasses,
                experiencedIndustries,
                largeTasks,
                middleTasks,
            };
            const initialValues = this.getInitialValues(props, categoryStates);
            return Object.assign(Object.assign(Object.assign({}, state), categoryStates), { initialValues });
        };
        this.setOnSubmitCompleteCallback = (callback) => {
            this.onSubmitCompleteCallback = callback;
        };
        this.state = this.getState(props, {});
        this.onSubmitCompleteCallback = null;
    }
    componentDidMount() {
        const { auth, profile, showAlert } = this.props;
        if (!hasRequiredParam(auth, profile)) {
            showAlert('プロフィール情報が不十分です。必須項目を入力してください。');
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { baseSkills, experienceClasses, experiencedIndustries, largeTasks, middleTasks, profile, } = this.props;
        if (profile !== nextProps.profile ||
            baseSkills !== nextProps.baseSkills ||
            experienceClasses !== nextProps.experienceClasses ||
            experiencedIndustries !== nextProps.experiencedIndustries ||
            largeTasks !== nextProps.largeTasks ||
            middleTasks !== nextProps.middleTasks) {
            this.setState(this.getState(nextProps, nextState));
            return false;
        }
        return true;
    }
    render() {
        var _a;
        const { profile } = this.props;
        const { baseSkills, experienceClasses, experiencedIndustries, initialValues, largeTasks, middleTasks, } = this.state;
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main', sticky: _jsx(OuterFormConsultantProfileSticky, { formName: 'FormProfileEdit', previewUrl: `/free_consultant/${(_a = profile === null || profile === void 0 ? void 0 : profile.freeInformation) === null || _a === void 0 ? void 0 : _a.nominalNumber}`, setOnSubmitCompleteCallback: this.setOnSubmitCompleteCallback }) }, { children: [_jsx("header", Object.assign({ className: 'l-sub-header l-sub-header-profile l-container-12' }, { children: _jsx("h1", { children: "Profile" }) })), _jsx("div", Object.assign({ className: 'l-container l-contents-form l-container-9 md-l-container-full' }, { children: _jsx(FormProfileEdit, { baseSkills: baseSkills, enableReinitialize: true, experienceClasses: experienceClasses, experiencedIndustries: experiencedIndustries, initialValues: initialValues, largeTasks: largeTasks, middleTasks: middleTasks, onSubmit: this.onSubmit }) }))] })));
    }
}
ProfileEdit.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    baseSkills: propArrayShape(),
    experienceClasses: propArrayShape(),
    experiencedIndustries: propArrayShape(),
    largeTasks: propArrayShape(),
    middleTasks: propArrayShape(),
    profile: propShape().isRequired,
    showAlert: propFunc().isRequired,
    showNotification: propFunc().isRequired,
    updateProfile: propFunc().isRequired,
    uploadFile: propFunc().isRequired,
};
ProfileEdit.defaultProps = {
    baseSkills: [],
    experienceClasses: [],
    experiencedIndustries: [],
    largeTasks: [],
    middleTasks: [],
};
const mapStateToProps = ({ auth, category, profile }) => ({
    auth,
    baseSkills: category.baseSkills,
    experienceClasses: category.experienceClasses,
    experiencedIndustries: category.experiencedIndustryClasses,
    largeTasks: category.largeTasks,
    middleTasks: category.middleTasks,
    profile,
});
const mapDispatchToProps = (dispatch) => ({
    showAlert: (message) => dispatch(showAlertAction(message)),
    showNotification: (message) => dispatch(showNotificationAction(message)),
    updateProfile: (values) => new Promise((resolve, reject) => {
        dispatch(apiUpdateProfile(values, {
            form: 'FormProfileEdit',
            reject,
            resolve,
        }));
    }),
    uploadFile: (file) => uploadFilePromiseAndGetTemporaryId({ dispatch, file }),
});
const enhance = compose(AuthenticationHoc({ isFreeProfessional: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(ProfileEdit);
